export const RECAPTCHA_MODES = Object.freeze([
  "disabled",
  "observe",
  "enforce",
] as const);

export type RecaptchaMode = typeof RECAPTCHA_MODES[number];
export type RecaptchaVerificationMode = Exclude<RecaptchaMode, "disabled">;

export const RECAPTCHA_MODE_HEADER = "x-fork-recaptcha-mode";

export function parseRecaptchaMode(value: unknown): RecaptchaMode {
  if (
    typeof value !== "string" ||
    !(RECAPTCHA_MODES as readonly string[]).includes(value)
  ) {
    throw new Error("recaptcha_mode_invalid");
  }
  return value as RecaptchaMode;
}
